import React, { useState } from "react";
import CardCentral from "../../components/Card";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";
import TextField from "@material-ui/core/TextField";
import { Button, Link } from "@material-ui/core";
import { Link as RouterLink, useHistory } from "react-router-dom";
import UsuarioService from "../../services/usuarioService";
import { toast } from "react-toastify";

const RedefinirSenha = (props) => {
    const classes = useStyles();
    const history = useHistory();

    const [email, setEmail] = useState("");

    const submitRedefinirSenha = async (event) => {
        event.preventDefault();
        try {
            let res = await UsuarioService.redefinirSenha(email);
            toast.success(
                "Senha redefinida com sucesso, verifique seu e-mail!",
                {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
            history.replace("/login");
        } catch (e) {
            toast.error("Erro ao redefinir senha, contate o administrador!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    return (
        <CardCentral>
            <>
                <Typography
                    component={"span"}
                    className={classes.header}
                    variant="h5"
                    gutterBottom>
                    Recuperar senha
                </Typography>
                <Typography
                    component={"p"}
                    variant="body2"
                    className={classes.subHeader}>
                    Insira o endereço de email associado a sua conta.
                </Typography>
                <form className={classes.form} onSubmit={submitRedefinirSenha}>
                    <div className={classes.margin}>
                        <TextField
                            size="small"
                            label="Email"
                            variant="outlined"
                            type="email"
                            fullWidth={true}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className={`${classes.margin} ${classes.subForm}`}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary">
                            Me envie instruções
                        </Button>
                    </div>
                </form>
                <div className={classes.footer}>
                    <Typography
                        component={"p"}
                        variant="body2"
                        className={classes.margin}>
                        <Link
                            component={RouterLink}
                            to="/login"
                            color="secondary">
                            Voltar para o Entrar
                        </Link>
                    </Typography>
                </div>
            </>
        </CardCentral>
    );
};

export default RedefinirSenha;
